export * from './window.provider';
